import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
	email: Yup.string().email().min(6).required(),
});
